import BaseController from "./base_controller"

export default class extends BaseController {
  static targets = ['form']
  static values = { successMessage: String }

  async submit() {
    const form = this.formTarget
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })

    if (response.ok) {
      form.reset()
      this.dispatchNotify(this.successMessageValue)
    }
  }
}
